<template>
    <Page header="Курсы" type="" :nopadding="false" header_pos="left">
        <template #body>
            <div class="w-full flex flex-column gap-3 overflow-hidden">
                <div v-if="!loading || rates.length" class="w-full overflow-hidden" style="max-width:100%">
                    <AdminRatesList
                        :rates="rates"
                        :totalRecords="totalRecords"
                        :loading="loading"
                        :defaultParams="lazyParams"
                        @filter="setFilter"
                        @lazyParams="setParams"
                        @open="openRate"
                    />
                </div>
                <Skeleton v-else width="100%" height="30px" />
            </div>
        </template>
    </Page>
</template>

<script>
import Page from '@/components/public/page.vue'
import AdminRatesList from '@/components/admin/rates/list.vue'

const getDefaultFilters = () => ({
    from: { value: '', matchMode: 'contains' },
    to: { value: '', matchMode: 'contains' },
})

export default {
    components: {
        Page,
        AdminRatesList,
    },
    data() {
        return {
            lazyParams: {
                rows: 10,
                first: 0,
                sortField: '_id',
                sortOrder: -1,
                // sort: { field: '_id', order: -1 },
                sort: {  },
                filters: getDefaultFilters(),
            }
        }
    },
    computed: {
        rates() {
            return this.$store.getters.StateAdminRates || []
        },
        totalRecords() {
            return this.$store.getters.StateAdminRatesTotal || 0
        },
        loading() {
            return this.$store.getters.StateAdminRatesLoadingList
        },
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({ severity, summary, detail, life: 3000 })
        },
        async loadRates() {
            const result = await this.$store.dispatch('ActionAdminRatesList', {
                limit: this.lazyParams.rows,
                skip: this.lazyParams.first,
                filter: this.lazyParams.filters,
                sort: this.lazyParams.sort,
            })

            if (!result.result) {
                this.showMess('error', 'Ошибка', 'Ошибка при загрузке курсов')
            }
        },
        setFilter(filters) {
            this.lazyParams.filters = filters
            this.lazyParams.first = 0
            this.loadRates()
        },
        setParams(params) {
            this.lazyParams = {
                ...this.lazyParams,
                ...params,
            }
            this.loadRates()
        },
        async openRate(rate) {
            await this.$store.dispatch('ActionAdminSelectRate', rate)
            this.$router.push(`/admin/rates/${rate._id || rate.id}`)
        },
    },
    mounted() {
        this.loadRates()
    }
}
</script>